import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Form,
} from "reactstrap";
import "./index.css";
import { useTab } from "@mui/base";
import { Field, Formik } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import SvgImage from "../../../Icons/Icons";
import moment from "moment";
import {
  createCustomerAction,
  getAllCustomersAction,
} from "../../../../services/Store/Actions/customerAction";
import AddDriverV2 from "../../../TripsMainV2/Components/AddDriverV2";
import AddVehicleV2 from "../../../TripsMainV2/Components/AddVehicleV2";
import { toastStatus } from "../../../../services/Store/Actions/appActions";
import { useNavigate } from "react-router-dom";
import {
  addTripAddress,
  getAddressFromPincodeAction,
  getPinCodeData,
  getSavedAddress,
  findTripAddressV2,
  addDriverV2,
} from "../../../../services/Store/Actions/TripsAction";
import AddAddress from "../../../LoadReceipt/Components/AddAddress";
import { Checkbox } from "@material-ui/core";
import PinInput from "react-pin-input";
import {
    customerMiniKyc,
  registorNewCustomer,
  registorNewCustomerVerifyOtpSuccess,
} from "../../../../services/Store/Actions/walletAction";
import { registorNewCustomerVerifyOtp } from "../../../../services/Store/Actions/walletAction";
import FormPicker from "../../../core/FormPicker";
import { DatePickerField } from "../../../core/inputs/input";

function MinKycModal(props) {
  const { toggle, modal, setModal, navigatedFrom,userData } = props;
  console.log("navigatedFromaaa", props?.userId);
  const [openToast, setOpenToast] = useState(false);
  const [temp, setTemp] = useState(navigatedFrom);
  const [display1, setDisplay1] = useState(false);
  const [search1, setSearch1] = useState("");
  const [color1, setColor1] = useState(-1);
  const [address, setAddress] = useState(false);
  const addAddress = () => setAddress(!address);
  console.log("navigatedFrom2222", temp);

  const [addressList, setAddressList] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { savedAddresses } = useSelector((state) => state?.trip);
  const toastObject = useSelector((state) => state?.app?.toastObject);
  const validationSchema = Yup.object().shape({
    firstName: Yup.string().required("Please enter your First name"),
    phone: Yup.string()
      .required("Phone number must contain 10 digits")
      .matches(
        /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/,
        "Phone number must contain 10 digits"
      ),
  });
  const handleClose = () => {
    setModal(!modal);
  };
  useEffect(() => {
    if (display1 == true) {
      // dispatch(findTripAddressV2({},(res)=>{
      //   console.log("findTripAddressV2",res);
      // }))
      dispatch(
        getSavedAddress({ address: search1 }, (res) => {
          console.log("getSavedAddress", res);
        })
      );
    }
  }, [display1, search1]);
  const [phone, setPhone] = useState("");

  const [send, setSend] = useState(false);
  const datepickerRefEnd = useRef();

  const verifyOtp = (otp) => {
    dispatch(
      registorNewCustomerVerifyOtp(
        {
          phone: phone,
          otp: otp,
        },
        (resp) => {
          console.log("uuuufuufufu", resp);
        }
      )
    );
  };
  const handleClickDatepickerIcon2 = () => {
    const datepickerElement = datepickerRefEnd.current;
    // console.log("datepickerElement = ", datepickerElement);
    datepickerElement.setOpen(!datepickerElement.open);
  };

  const [display, setDisplay] = useState(false);
  const [color, setColor] = useState(-1);

  return (
    <div>
      <Modal
        isOpen={modal}
        onHide={handleClose}
        className=" modal-dialog-centered model-width model-Radius"
        toggle={toggle}
        aria-labelledby="myModalLabel2"
      >
        <ModalBody
          className="transactionModalBody"
          //   style={{ marginTop: "25px" }}
        >
          <div className="closeBtnWithBackground" onClick={handleClose}>
            <SvgImage
              classname="close-btn-text"
              style={{ width: "10%", height: "10%" }}
              name="crossBtnWIthBackground"
              width="20%"
              height="20%"
            />
          </div>
          <div
            style={{ marginTop: " 30px" }}
            //   className="PGCollectionBox"
          >
            <div
              className="PGCollectiontText col-9"
              style={{ marginLeft: "50px" }}
            >
              Complete Driver KYC
            </div>

            <Formik
              // isValid='true'
              enableReinitialize
              //   validationSchema={validationSchema}
              initialValues={{
                fullName: userData?.fullName || "",
                aadhar:  userData?.aadhar || "",
                dob:  userData?.dateOfBirth || "",
                gender:  userData?.gender || "",
                pincode:  userData?.pincode || "",
                address:  userData?.address || "",
                Occupation: userData?.fullName ?  "SALARIED" : "",
                annualIncome: userData?.fullName ?  "1L-5L" : "",
                purpose: userData?.fullName ?   "INCENTIVE" : "",
                fund: userData?.fullName ?  "SALARY" : "",
                qualification: userData?.fullName ? "UNDER GRADUATE" : "",
              }}
              autocomplete="off"
              onSubmit={(values) => {
                console.log("bjhbiufhuieg", values);
                const dob = moment(values?.dob).format("YYYY-MM-DD")
                const payload = {
                  userId: props.userId,
                  fullName: values?.fullName?.trim(),
                  dateOfBirth: dob,
                  address: values?.address?.trim(),
                  gender: values?.gender,
                  pincode: values?.pincode,
                  aadhar: values?.aadhar,
                  profession: values?.Occupation,
                  annualIncome: values?.annualIncome,
                  purpose: values?.purpose,
                  sourceOfFund: values?.fund,
                  educationQualification: values?.qualification,
                  selfEmployedProfession: values?.selfEmployedProfession,
                  natureOfBusiness: values?.natureOfBusiness,
                };
                dispatch(customerMiniKyc(payload, (res) => {
                    console.log("kkksssss",res)
                    if (res.status == 200 && res?.data?.type == 'success' && res?.data?.data?.code == 'M09') {
                      handleClose();
                    }
                }))
              }}
            >
              {({
                handleBlur,
                handleChange,
                handleSubmit,
                setFieldValue,
                values,
                touched,
                isValid,
                errors,
              }) => (
                <Form
                  onSubmit={handleSubmit}
                  style={{ marginTop: "40px", padding: "0 0px 0 55px" }}
                >
                  <FormGroup>
                    <div className="row">
                      <div className="col-4 row">
                        <div className="col-12">
                          <label for="vrn" className="heading3 semiBold">
                            Full name
                          </label>
                        </div>
                        <div className="col-12" style={{ padding: "8px" }}>
                          <input
                            type="text"
                            id="fullName"
                            className={`inputBoxAddCust ${
                              touched.fullName && errors.fullName
                                ? "is-invalid"
                                : ""
                            }`}
                            name="fullName"
                            value={values.fullName}
                            onChange={handleChange("fullName")}
                            onBlur={handleBlur("fullName")}
                            touched={touched.fullName}
                            errors={errors.fullName}
                            placeholder="Full name"
                          />
                          <div
                            style={{ margin: "7px 0 0px 5px", color: "red" }}
                          >
                            {errors.fullName && touched.fullName ? (
                              <div>*{errors.fullName}</div>
                            ) : null}
                          </div>
                        </div>
                      </div>
                      <div className="col-4 row">
                        <div className="col-12">
                          <label for="vrn" className="heading3 semiBold">
                            Enter Aadhaar No.
                          </label>
                        </div>
                        <div className="col-12" style={{ padding: "8px" }}>
                          <input
                            type="text"
                            id="aadhar"
                            className={`inputBoxAddCust ${
                              touched.aadhar && errors.aadhar
                                ? "is-invalid"
                                : ""
                            }`}
                            name="aadhar"
                            value={values.aadhar}
                            onChange={handleChange("aadhar")}
                            onBlur={handleBlur("aadhar")}
                            touched={touched.aadhar}
                            errors={errors.aadhar}
                            placeholder="Enter Aadhaar No."
                          />
                          <div
                            style={{ margin: "7px 0 0px 5px", color: "red" }}
                          >
                            {errors.aadhar && touched.aadhar ? (
                              <div>*{errors.aadhar}</div>
                            ) : null}
                          </div>
                        </div>
                      </div>
                    </div>
                  </FormGroup>
                  <FormGroup
                    // style={{
                    //   display: "flex",
                    //   alignItems: "center",
                    //   justifyContent: "space-between",
                    //   marginTop: "30px",
                    // }}
                    style={{
                      padding: "0px 0 0 0",
                    }}
                  >
                    <div className="row">
                      <div className="col-4 row">
                        <div className="col-12">
                          <label for="vrn" className="heading3 semiBold">
                            Date of Birth
                          </label>
                        </div>
                        <div className="col-12" style={{ padding: "8px" }}>
                          <div
                            className="searchBox"
                            style={{ width: "200px", borderRadius: "8px" }}
                          >
                            <DatePickerField
                              classname="searchBar-input"
                              name="dob"
                              header="Select Date of Birth"
                              value={values.dob}
                              onChange={(v) => {
                                setFieldValue("dob", v, true);
                              }}
                              //onChange={(v) => setFieldValue("endDate", v, true)}
                              // minDate={
                              //   values.startDate === "" ? "" : values.startDate
                              // }
                              // maxDate={new Date()}
                              ref1={datepickerRefEnd}
                              style={{ width: "100px" }}
                            />
                            <label
                              className="date-input"
                              for="startDate"
                              style={{
                                position: "relative",
                                top: "-5px",
                                left: "-2rem",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                handleClickDatepickerIcon2();
                              }}
                            >
                              <SvgImage
                                name="CalenderLogo"
                                width="32"
                                height="32"
                              />
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="col-8 row">
                        <div className="col-12">
                          <label for="vrn" className="heading3 semiBold">
                            Gender
                          </label>
                        </div>
                        <div className="col-12 row" style={{ padding: "8px" }}>
                          <div className="col-5 row">
                            <div className="col-3">
                              <Checkbox
                                value={values?.gender}
                                sx={{
                                  color: "#6c6c6c",
                                  "&.Mui-checked": {
                                    color: "#2E7C7B",
                                  },
                                }}
                                  onChange={(e) => {
                                    setFieldValue("gender", "male", true);
                                  }}
                                  checked={values?.gender == "male" ? true : false}
                              />
                            </div>
                            <div
                              className="col-6"
                              style={{
                                padding: "9px 0 0 0",
                              }}
                            >
                              Male
                            </div>
                          </div>
                          <div className="col-5 row">
                            <div className="col-3">
                              <Checkbox
                                value={values?.gender}
                                sx={{
                                  color: "#6c6c6c",
                                  "&.Mui-checked": {
                                    color: "#2E7C7B",
                                  },
                                }}
                                checked={values?.gender == "female" ? true : false}
                                  onChange={(e) => {
                                    setFieldValue("gender", "female", true);
                                  }}
                              />
                            </div>
                            <div
                              className="col-6"
                              style={{
                                padding: "9px 0 0 0",
                              }}
                            >
                              Female
                            </div>
                          </div>
                          <div
                            style={{ margin: "7px 0 0px 5px", color: "red" }}
                          >
                            {errors.phone && touched.phone ? (
                              <div>*{errors.phone}</div>
                            ) : null}
                          </div>
                        </div>
                      </div>
                    </div>
                  </FormGroup>
                  <FormGroup
                    // style={{
                    //   display: "flex",
                    //   alignItems: "center",
                    //   justifyContent: "space-between",
                    // }}
                    style={{
                      padding: "0px 0 0 0",
                    }}
                  >
                    <div className="row">
                      <div className="col-4 row">
                        <div className="col-12">
                          <label for="vrn" className="heading3 semiBold">
                            Pincode
                          </label>
                        </div>
                        <div className="col-12" style={{ padding: "8px" }}>
                          <input
                            type="text"
                            id="pincode"
                            className={`inputBoxAddCust ${
                              touched.pincode && errors.pincode
                                ? "is-invalid"
                                : ""
                            }`}
                            name="pincode"
                            value={values.pincode}
                            onChange={handleChange("pincode")}
                            onBlur={handleBlur("pincode")}
                            touched={touched.pincode}
                            errors={errors.pincode}
                            placeholder="Contact Person Name"
                          />
                          <div
                            style={{ margin: "7px 0 0px 5px", color: "red" }}
                          >
                            {errors.pincode && touched.pincode ? (
                              <div>*{errors.pincode}</div>
                            ) : null}
                          </div>
                        </div>
                      </div>
                      <div className="col-4 row">
                        <div className="col-12">
                          <label for="vrn" className="heading3 semiBold">
                            Address
                          </label>
                        </div>
                        <div className="col-12" style={{ padding: "8px" }}>
                          <input
                            type="text"
                            id="address"
                            className={`inputBoxAddCust ${
                              touched.address && errors.address
                                ? "is-invalid"
                                : ""
                            }`}
                            style={{ width: "461px" }}
                            name="address"
                            value={values.address}
                            onChange={handleChange("address")}
                            onBlur={handleBlur("address")}
                            touched={touched.address}
                            errors={errors.address}
                            placeholder="Address"
                          />
                          <div
                            style={{ margin: "7px 0 0px 5px", color: "red" }}
                          >
                            {errors.address && touched.address ? (
                              <div>*{errors.address}</div>
                            ) : null}
                          </div>
                        </div>
                      </div>
                    </div>
                  </FormGroup>
                  <FormGroup
                    // style={{
                    //   display: "flex",
                    //   alignItems: "center",
                    //   justifyContent: "space-between",
                    // }}
                    style={{
                      padding: "0px 0 0 0",
                    }}
                  >
                    <div className="row">
                      <div className="col-4 row">
                        <div className="col-12">
                          <label for="vrn" className="heading3 semiBold">
                            Occupation
                          </label>
                        </div>
                        <div className="col-12" style={{ padding: "8px" }}>
                          <input
                            type="text"
                            id="tripNo"
                            className={`inputBoxAddCust ${
                              touched.Occupation && errors.Occupation
                                ? "is-invalid"
                                : ""
                            }`}
                            name="Occupation"
                            value={values.Occupation}
                            onChange={() => {
                              setDisplay("Occupation");
                            }}
                            onFocus={() => {
                              setDisplay("Occupation");
                            }}
                            touched={touched.Occupation}
                            errors={errors.Occupation}
                            placeholder="Contact Person Name"
                            onBlur={() => {
                              handleBlur("regNumber");
                              setDisplay("");
                            }}
                          />
                          <FormPicker
                            placeholder="Search"
                            // text="Select by driver name"
                            listing={[
                              "SALARIED",
                              "AGRICULTURE",
                              "HOME MAKER",
                              "STUDENT",
                              "NOT WORKING",
                              "RETIRED",
                            ]}
                            parameter="Occupation"
                            minWidth={"180"}
                            // handlingDivSelect={handlingDivSelect}
                            display={display}
                            setDisplay={setDisplay}
                            // displayVehicles={displayVehicles}
                            // setDisplayVehicles={setDisplayVehicles}
                            color={color}
                            setColor={setColor}
                            //   loading={loading}
                            setFieldValue={setFieldValue}
                            setFieldParameter={"Occupation"}
                            header={"Occupation"}
                            autocomplete="off"
                            // userId={userId}
                            // setUserId={setUserId}
                          />
                          <div
                            style={{ margin: "7px 0 0px 5px", color: "red" }}
                          >
                            {errors.Occupation && touched.Occupation ? (
                              <div>*{errors.Occupation}</div>
                            ) : null}
                          </div>
                        </div>
                      </div>
                      <div className="col-4 row">
                        <div className="col-12">
                          <label for="vrn" className="heading3 semiBold">
                            Annual Income
                          </label>
                        </div>
                        <div className="col-12" style={{ padding: "8px" }}>
                          <input
                            type="text"
                            id="annualIncome"
                            className={`inputBoxAddCust ${
                              touched.annualIncome && errors.annualIncome
                                ? "is-invalid"
                                : ""
                            }`}
                            name="annualIncome"
                            value={values.annualIncome}
                            onChange={() => {
                              setDisplay("annualIncome");
                            }}
                            onFocus={() => {
                              setDisplay("annualIncome");
                            }}
                            touched={touched.annualIncome}
                            errors={errors.annualIncome}
                            placeholder="Contact Person Name"
                            onBlur={() => {
                              handleBlur("regNumber");
                              setDisplay("");
                            }}
                          />
                          <FormPicker
                            placeholder="Search"
                            // text="Select by driver name"
                            listing={[
                              "0-1L",
                              "1L-5L",
                              "5L-10L",
                              "10L-25L",
                              "25L-50L",
                              "50L-1C",
                            ]}
                            parameter="annualIncome"
                            minWidth={"180"}
                            // handlingDivSelect={handlingDivSelect}
                            display={display}
                            setDisplay={setDisplay}
                            // displayVehicles={displayVehicles}
                            // setDisplayVehicles={setDisplayVehicles}
                            color={color}
                            setColor={setColor}
                            //   loading={loading}
                            setFieldValue={setFieldValue}
                            setFieldParameter={"annualIncome"}
                            header={"annualIncome"}
                            autoComplete="off"
                            // userId={userId}
                            // setUserId={setUserId}
                          />
                          <div
                            style={{ margin: "7px 0 0px 5px", color: "red" }}
                          >
                            {errors.annualIncome && touched.annualIncome ? (
                              <div>*{errors.annualIncome}</div>
                            ) : null}
                          </div>
                        </div>
                      </div>
                      <div className="col-4 row">
                        <div className="col-12">
                          <label for="vrn" className="heading3 semiBold">
                            Purpose
                          </label>
                        </div>
                        <div className="col-12" style={{ padding: "8px" }}>
                          <input
                            type="text"
                            id="purpose"
                            className={`inputBoxAddCust ${
                              touched.purpose && errors.purpose
                                ? "is-invalid"
                                : ""
                            }`}
                            name="purpose"
                            value={values.purpose}
                            onChange={() => {
                              setDisplay("purpose");
                            }}
                            onFocus={() => {
                              setDisplay("purpose");
                            }}
                            touched={touched.purpose}
                            errors={errors.purpose}
                            placeholder="Contact Person Name"
                            onBlur={() => {
                              handleBlur("regNumber");
                              setDisplay("");
                            }}
                            autoComplete="off"
                          />
                          <FormPicker
                            placeholder="Search"
                            // text="Select by driver name"
                            listing={["GENERAL", "INCENTIVE", "GIFT"]}
                            parameter="purpose"
                            minWidth={"180"}
                            // handlingDivSelect={handlingDivSelect}
                            display={display}
                            setDisplay={setDisplay}
                            // displayVehicles={displayVehicles}
                            // setDisplayVehicles={setDisplayVehicles}
                            color={color}
                            setColor={setColor}
                            //   loading={loading}
                            setFieldValue={setFieldValue}
                            setFieldParameter={"purpose"}
                            header={"purpose"}
                            // userId={userId}
                            // setUserId={setUserId}
                          />
                          <div
                            style={{ margin: "7px 0 0px 5px", color: "red" }}
                          >
                            {errors.purpose && touched.purpose ? (
                              <div>*{errors.purpose}</div>
                            ) : null}
                          </div>
                        </div>
                      </div>
                    </div>
                  </FormGroup>
                  <FormGroup
                    style={{
                      padding: "0px 0 0 0",
                    }}
                  >
                    <div className="row">
                      <div className="col-4 row">
                        <div className="col-12">
                          <label for="vrn" className="heading3 semiBold">
                            Source of fund
                          </label>
                        </div>
                        <div className="col-12" style={{ padding: "8px" }}>
                          <input
                            type="text"
                            id="fund"
                            className={`inputBoxAddCust ${
                              touched.fund && errors.fund ? "is-invalid" : ""
                            }`}
                            name="fund"
                            value={values.fund}
                            onChange={() => {
                              setDisplay("fund");
                            }}
                            onFocus={() => {
                              setDisplay("fund");
                            }}
                            touched={touched.fund}
                            errors={errors.fund}
                            placeholder="Contact Person Name"
                            onBlur={() => {
                              handleBlur("regNumber");
                              setDisplay("");
                            }}
                          />
                          <FormPicker
                            placeholder="Search"
                            // text="Select by driver name"
                            listing={[
                              "WAGES",
                              "SALARY",
                              "GIFT",
                              "COMMISSION",
                              "INCOME FROM RENT",
                              "PENSION",
                              "INCOME FROM AGRICULTURE",
                              "ROYALTY",
                              "INCOME FROM BUSINES",
                              "INCOME FROM INVESTMENT",
                              "FAMILY INCOME",
                              "FEES",
                            ]}
                            parameter="fund"
                            minWidth={"180"}
                            // handlingDivSelect={handlingDivSelect}
                            display={display}
                            setDisplay={setDisplay}
                            // displayVehicles={displayVehicles}
                            // setDisplayVehicles={setDisplayVehicles}
                            color={color}
                            setColor={setColor}
                            //   loading={loading}
                            setFieldValue={setFieldValue}
                            setFieldParameter={"fund"}
                            header={"fund"}
                            // userId={userId}
                            // setUserId={setUserId}
                          />
                          <div
                            style={{ margin: "7px 0 0px 5px", color: "red" }}
                          >
                            {errors.fund && touched.fund ? (
                              <div>*{errors.fund}</div>
                            ) : null}
                          </div>
                        </div>
                      </div>
                      <div className="col-4 row">
                        <div className="col-12">
                          <label for="vrn" className="heading3 semiBold">
                            Educational Qualification
                          </label>
                        </div>
                        <div className="col-12" style={{ padding: "8px" }}>
                          <input
                            type="text"
                            id="qualification"
                            className={`inputBoxAddCust ${
                              touched.qualification && errors.qualification
                                ? "is-invalid"
                                : ""
                            }`}
                            name="qualification"
                            value={values.qualification}
                            onChange={() => {
                              setDisplay("qualification");
                            }}
                            onFocus={() => {
                              setDisplay("qualification");
                            }}
                            touched={touched.qualification}
                            errors={errors.qualification}
                            placeholder="Contact Person Name"
                            onBlur={() => {
                              handleBlur("regNumber");
                              setDisplay("");
                            }}
                          />
                          <FormPicker
                            placeholder="Search"
                            // text="Select by driver name"
                            listing={[
                              "GRADUATE",
                              "POST GRADUATE",
                              "UPTO 10",
                              "UNDER GRADUATE",
                              "PROFESSIONAL",
                              "NOT APPLICABLE",
                            ]}
                            parameter="qualification"
                            minWidth={"190"}
                            // handlingDivSelect={handlingDivSelect}
                            display={display}
                            setDisplay={setDisplay}
                            // displayVehicles={displayVehicles}
                            // setDisplayVehicles={setDisplayVehicles}
                            color={color}
                            setColor={setColor}
                            //   loading={loading}
                            setFieldValue={setFieldValue}
                            setFieldParameter={"qualification"}
                            header={"qualification"}
                            // userId={userId}
                            // setUserId={setUserId}
                          />
                          <div
                            style={{ margin: "7px 0 0px 5px", color: "red" }}
                          >
                            {errors.qualification && touched.qualification ? (
                              <div>*{errors.qualification}</div>
                            ) : null}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style={{ textAlign: "center" }}>
                      <Button
                        type="submit"
                        style={{ width: "160px", borderRadius: "5px" }}
                        className="generateOtp textAddCust Medium btn btn-secondary"
                        // onClick={addFreight}
                      >
                        Done
                      </Button>
                    </div>
                  </FormGroup>
                </Form>
              )}
            </Formik>
          </div>
        </ModalBody>
      </Modal>
      {console.log("createLRModal", navigatedFrom, toastObject)}
      <AddAddress
        toggle={addAddress}
        address={address}
        setAddress={setAddress}
      />
    </div>
  );
}

export default MinKycModal;
